// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__XkzUL","dragIcon":"Choice_dragIcon__3250H","left":"Choice_left__2YIgg","input":"Choice_input__yAR3w"};